module.exports = __webpack_public_path__ + "static/img/WILL-PATTON.d65cd5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WILL-PATTON.jpg
// module id = cX9d
// module chunks = 0